import request from '@/router/axios'

export function getPage(query) {
    return request({
        url: '/chain/garbageTicket/ticketCount',
        method: 'get',
        params: query
    })
}
